import React from 'react';
import { useI18n } from '@udemy/i18n';
import { udLink, useSiteStats } from '@udemy/ud-data';
import { getPartnersBannerHeading, getPartnersLogos } from './constants';
import { useFetchPartnersLogos } from './hooks/use-fetch-partners-logos';
import { PartnersBannerSkeleton } from './partners-banner-skeleton.react-component';
import { PartnersBanner } from './partners-banner.react-component';
export const CMSConnectedPartnersBanner = ({
  pageType,
  headingAlignment
}) => {
  const {
    isLoading,
    isError,
    data
  } = useFetchPartnersLogos(pageType);
  const i18nApi = useI18n();
  const {
    getOrgNumericSiteStat
  } = useSiteStats();
  const partnerLogos = getPartnersLogos(udLink);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(PartnersBannerSkeleton, {
      numLogos: partnerLogos.length
    });
  } else if (isError || !(data !== null && data !== void 0 && data.contents) || data.contents.length === 0 || !data.heading) {
    // use fallback data
    return /*#__PURE__*/React.createElement(PartnersBanner, {
      heading: getPartnersBannerHeading(i18nApi, getOrgNumericSiteStat),
      headingAlignment: headingAlignment,
      logos: partnerLogos
    });
  }
  const logos = data.contents.map(content => {
    var _content$image, _content$image2;
    return {
      img: content === null || content === void 0 || (_content$image = content.image) === null || _content$image === void 0 ? void 0 : _content$image.url,
      name: (content === null || content === void 0 || (_content$image2 = content.image) === null || _content$image2 === void 0 ? void 0 : _content$image2.altText) || ''
    };
  });
  return /*#__PURE__*/React.createElement(PartnersBanner, {
    heading: data.heading,
    headingAlignment: headingAlignment,
    logos: logos
  });
};
//# sourceMappingURL=cms-connected-partners-banner.react-component.js.map